import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    messageTitle: {
        id: 'notifications.deposit.success.message.title',
        defaultMessage: 'Message:',
    },
})
